<template>
  <div class="info">
    <span>{{ record.excerpt_for_idu }}</span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      record: {},
    };
  },
  mounted() {
    this.record = this.params.data;
  },
  methods: {
    // called when the cell is refreshed
    refresh() {
      return false;
    },
  },
};
</script>

<style scoped>
.info {
  overflow-wrap: break-word;
  font-size: 1.2em;
  color: steelblue;
  margin: 6px;
  padding: 12px;
}
</style>
